import React from "react";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";

const TEPCard = (props) => {
  const {
    filterType,
    cardImg,
    total,
    cardTitle,
    rupeeAmount,
    allOverRupeeAmount,
    memberCount,
    amountString,
    onClickCard,
    cardName,
    isLoading,
    isRupee,
    isTrainerValue,
    totalAmount,
    cardNotClickable,
    amountSubTitle,
    isCardImgNotRequired,
  } = props || {};

  let canClick;
  if (
    isLoading ||
    filterType === "total_pt_revenue" ||
    filterType === "full_partial_pt_amount" ||
    filterType === "total_subscription" ||
    filterType === "full_partial_pt_subscription" ||
    cardNotClickable
  ) {
    canClick = false;
  } else {
    canClick = true;
  }

  return (
    <div
      className={`cards-child ${
        filterType === "pt_revenue" || filterType === "pt_partial"
          ? "spanTwo"
          : ""
      } ${cardName === "trainer-details" ? "iconLast" : ""}`}
      onClick={() => (!canClick ? null : onClickCard(filterType))}
      style={{
        cursor: !canClick ? "not-allowed" : "pointer",
      }}
    >
      {!isCardImgNotRequired && (
        <div className="cards-icon">
          <img src={cardImg} alt="Added By Me" className="card-icon-img" />
        </div>
      )}

      {isLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="cards-labels">
          {total || total === 0 ? (
            <p className="label-value">
              {total}
              {!isRupee ? (
                <span className="light-tag">
                  {isTrainerValue ? "Trainer(S)" : "Member(S)"}
                </span>
              ) : null}
            </p>
          ) : null}

          {totalAmount || totalAmount === 0 ? (
            <p className="label-value">{totalAmount}</p>
          ) : null}

          {rupeeAmount || rupeeAmount === 0 ? (
            <p className="label-value">
              ₹{rupeeAmount}{" "}
              <span className="light-tag">
                ({amountSubTitle ? amountSubTitle : "Today's"})
              </span>
            </p>
          ) : null}

          {allOverRupeeAmount || allOverRupeeAmount === 0 ? (
            <p className="label-value">
              ₹{allOverRupeeAmount} <span className="light-tag">(overall)</span>
            </p>
          ) : null}

          {memberCount || memberCount === 0 ? (
            <p className="label-value">
              {memberCount} <span className="light-tag">(Members)</span>
            </p>
          ) : null}

          {amountString || amountString === 0 ? (
            <p className="label-value">
              {amountString} <span className="light-tag">(Partial)</span>
            </p>
          ) : null}

          <span className="label-name">{cardTitle}</span>
        </div>
      )}
    </div>
  );
};

export default TEPCard;
